import { useLayoutEffect, useState } from 'react';

export const useWindowResize = () => {
    const [size, setSize] = useState([window.innerWidth, window.innerHeight, window.devicePixelRatio]);
    useLayoutEffect(() => {
        const updateSize = () => {
            setSize([window.innerWidth, window.innerHeight, window.devicePixelRatio]);
        };
        window.addEventListener('resize', updateSize);
        updateSize();
        return () => window.removeEventListener('resize', updateSize);
    }, []);
    return size;
};
